import {NotFoundPage as NotFoundPageUI} from "@pinch-financial/pinch-ui-components";
import {useTranslation} from "react-i18next";

const NotFoundPage = () => {
  const {t: fixedT} = useTranslation("", {keyPrefix: "notFoundPage"});
  return <NotFoundPageUI header={fixedT("header")} body1={fixedT("body")} />;
};

export default NotFoundPage;
